import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class GradientHero {
	constructor(dom) {
		this.NAME = "GradientHero";
		this.dom = dom;
	}

	init() {
		const innerEl = this.dom.querySelector(".gradient-hero__inner");
		const foregroundEl = this.dom.querySelector(".gradient-hero__foreground");

		if (innerEl) {
			gsap.fromTo(
				innerEl,
				{ y: "50%", scale: 0.9 },
				{
					y: "-50%",
					scale: 1,
					ease: "none",
					scrollTrigger: {
						trigger: this.dom,
						start: "top bottom",
						end: "bottom center",
						scrub: 0.8,
					},
				}
			);
		}

		if (foregroundEl) {
			gsap.fromTo(
				foregroundEl,
				{ y: -100, scale: 1.1 },
				{
					y: 0,
					scale: 1,
					ease: "none",
					scrollTrigger: {
						trigger: this.dom,
						start: "top bottom",
						end: "bottom bottom",
						scrub: 0.8,
					},
				}
			);
		}
	}
}

export default GradientHero;
